import { useState, createContext, useContext } from 'react'
import {
  MerchantCategory,
  Merchant,
  MerchantIntegration,
  MerchantLocation,
  StripeConnectData
} from '@slerp/controls'

type MerchantState = {
  merchantData: Merchant
  setMerchantData: (merchant: Merchant) => void
  refetchMerchantData: () => void
  setRefetchMerchantData: (refetch: () => void) => void
  merchantLocations: MerchantLocation[]
  setMerchantLocations: (locations: MerchantLocation[]) => void
  merchantCategories: MerchantCategory[]
  setMerchantCategories: (categories: MerchantCategory[]) => void
  archivedMerchantCategories: MerchantCategory[]
  setArchivedMerchantCategories: (categories: MerchantCategory[]) => void
  refetchCategories: () => void
  setRefetchCategories: (refetch: () => void) => void
  integrations: MerchantIntegration[]
  setIntegrations: (integrations: MerchantIntegration[]) => void
  refetchIntegrations: () => void
  setRefetchIntegrations: (refetch: () => void) => void
  stripeConnectData: StripeConnectData | null
  setStripeConnectData: (stripeConnectData: StripeConnectData | null) => void
  refetchStripeConnectData: () => void
  setRefetchStripeConnectData: (refetch: () => void) => void
}

export const SetupMerchant = (): MerchantState => {
  const [merchantData, setMerchantData] = useState<Merchant>({} as Merchant)
  const [refetchMerchantData, setRefetchMerchantData] = useState<() => void>(
    () => null
  )
  const [merchantLocations, setMerchantLocations] = useState<
    MerchantLocation[]
  >([])
  const [merchantCategories, setMerchantCategories] = useState<
    MerchantCategory[]
  >([])
  const [archivedMerchantCategories, setArchivedMerchantCategories] = useState<
    MerchantCategory[]
  >([])
  const [refetchCategories, setRefetchCategories] = useState<() => void>(
    () => null
  )
  const [integrations, setIntegrations] = useState<MerchantIntegration[]>([])
  const [refetchIntegrations, setRefetchIntegrations] = useState<() => void>(
    () => null
  )

  const [stripeConnectData, setStripeConnectData] =
    useState<StripeConnectData | null>(null)
  const [refetchStripeConnectData, setRefetchStripeConnectData] = useState<
    () => void
  >(() => null)

  return {
    merchantData,
    setMerchantData,
    refetchMerchantData,
    setRefetchMerchantData,
    merchantLocations,
    setMerchantLocations,
    merchantCategories,
    setMerchantCategories,
    archivedMerchantCategories,
    setArchivedMerchantCategories,
    setRefetchCategories,
    refetchCategories,
    integrations,
    setIntegrations,
    refetchIntegrations,
    setRefetchIntegrations,
    stripeConnectData,
    setStripeConnectData,
    refetchStripeConnectData,
    setRefetchStripeConnectData
  }
}

const initialState: MerchantState = {
  merchantData: {} as Merchant,
  setMerchantData: () => null,
  refetchMerchantData: () => null,
  setRefetchMerchantData: () => null,
  merchantLocations: [],
  setMerchantLocations: () => null,
  merchantCategories: [],
  setMerchantCategories: () => null,
  archivedMerchantCategories: [],
  setArchivedMerchantCategories: () => null,
  refetchCategories: () => null,
  setRefetchCategories: () => null,
  integrations: [],
  setIntegrations: () => null,
  refetchIntegrations: () => null,
  setRefetchIntegrations: () => null,
  stripeConnectData: null,
  setStripeConnectData: () => null,
  refetchStripeConnectData: () => null,
  setRefetchStripeConnectData: () => null
}

export const MerchantContext = createContext<MerchantState>(initialState)

export const useMerchant = () => {
  return useContext(MerchantContext)
}
